<template>
    <div class="w-h" v-if="cameraInfo">
        <template v-if="cameraInfo.type === 5">
            <Huawei
                :id="'now_video' + cameraInfo.camera_device_id"
                :camera="cameraInfo" />
        </template>
        <template v-else>
            <template v-if="getCameraType == 'h264'">
                <Camera
                    :id="'now_video' + cameraInfo.camera_device_id"
                    :camera="cameraInfo"
                    :hls="cameraInfo.hls ? cameraInfo.hls : null"
                />
            </template>
            <template v-if="getCameraType == 'h265'">
                <VideoRecorder :hideBtnList="true" :array="[cameraInfo]" />
            </template>
        </template>
    </div>
</template>

<script>
import Camera from "./camera.vue";
import VideoRecorder from "./videoRecorder.vue";
import Huawei from "./huawei.vue";
import { checkCameraIsH265, ys } from "./tools/getYsToken.js";
export default {
    props: ["cameraInfo"],
    components: {
        Camera,
        VideoRecorder,
        Huawei
    },
    data() {
        return {
            getCameraType: null
        };
    },
    methods: {},
    mounted() {
        checkCameraIsH265(this.cameraInfo)
            .then(res => {
                if (res) {
                    this.cameraInfo.appKey = this.cameraInfo.appkey;
                    this.cameraInfo.appSecret = this.cameraInfo.appsecret;
                    ys.updateMap(this.cameraInfo);
                    ys.getToken(this.cameraInfo.id)
                        .then(token => {
                            this.cameraInfo.accessToken = token;
                            this.getCameraType = "h265";
                        })
                        .catch(err => {
                            this.$Message.error(err);
                        });
                } else {
                    this.getCameraType = "h264";
                }
            });
    }
};
</script>

<style scoped="scoped">
.w-h {
    width: 100%;
    height: 100%;
}
</style>
